import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { SERVER_BASE } from '../config/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPlus, faMinus, faEllipsisV, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';
import Swal from 'sweetalert2';
import apiClient from '../utils/apiClient';
import { useNavigate, useLocation } from 'react-router-dom';
const IssueRequest = ({ accessOfDepartments }) => {
  const [header, setHeader] = useState({
    date: '',
    receivingDepartment: null,
    issuerDepartment: null,
    remarks: '',
    project: null,
    transaction: null
  });
  const [inventory, setInventory] = useState([
    {
      item: null,
      quantity: '',
      approvedQuantity: '',   // ✅ NEW
      itemCode: '',
      uom: '',
      unit: '',
      returnable: null,
      itemRemarks: ''
    },
  ]);
  const transactionOptions = [
    { value: "Regular", label: "Regular" },
    { value: "Project", label: "Project" },
    { value: "AHQ", label: "AHQ" },
  ];
  const code = localStorage.getItem('code');
  const email = localStorage.getItem('email');
  const role = localStorage.getItem('role');
  const pin = localStorage.getItem("pin");
  const [profileDetails, setProfileDetails] = useState(null); // State for profile details
  const [departments, setDepartments] = useState([]);
  const [projects, setProjects] = useState([]);
  const token = localStorage.getItem('token');
  const [itemOptions, setItemOptions] = useState([]);
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const navigate = useNavigate()
  const location = useLocation()
  const draftId = location?.state?.id;
  const type = location?.state?.type

  useEffect(() => {
    fetchDepartments();
    fetchProfileDetails();
  }, []);
  useEffect(() => {
    const fetchRowData = async () => {
      try {

        const response = await apiClient.get(`${SERVER_BASE}/viewIssueRequest/${draftId}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Ensure token is valid
          },
        });
        const data = response.data;
        setHeader({
          date: data.requestDate ?? '',
          issuerDepartment: data.issuerDepartment ? { value: data.issuerDepartment, label: data.issuerDepartment } : null,
          receivingDepartment: data.receivingDepartment ? { value: data.receivingDepartment, label: data.receivingDepartment } : null,
          remarks: data.remarks ?? '',
          transaction: data.transaction ? { value: data.transaction, label: data.transaction } : null,
          project: data.projectId ? { value: data.projectId, label: data.projectName } : null,
        });
        setInventory(
          data.inventory?.map(item => ({
            item: {
              value: item.item, label: item.item, itemCode: item.itemCode,
              uom: item.uom,
              unit: item.unit, itemId: item.itemId
            } ?? null,
            quantity: item.quantity ?? '',
            approvedQuantity: item.approvedQuantity,
            returnable: item.returnable ? { value: item.returnable, label: item.returnable } : null,
            itemRemarks: item.itemRemarks || '',
            itemCode: item.itemCode ?? '',
            uom: item.uom ?? '',
            unit: item.unit ?? ''
          })) || []
        );
  
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchRowData();
  }, []);
  const fetchDepartments = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/departments`, {
        params: { code },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setDepartments(
        response.data
          .filter((department) => department.purposeType !== 'Less')
          .map((department) => ({
            value: department.name,
            label: department.name,
          }))
      );
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };
  useEffect(() => {
    apiClient.get(`${SERVER_BASE}/area-projects`).then(res => {
      setProjects(res.data.map(p => ({ value: p.id, label: p.projectName })));
    });
  }, []);
  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email, role } });
      setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
    } catch (err) {
      console.error('Error fetching profile details:', err);
      setProfileDetails(null);
    }
  };
  const fetchItemOptions = async (department) => {

    try {
      // Fetch the data separately from both routes
      const response = await apiClient.get(SERVER_BASE + "/getItemsByDept", {
        params: { centerCode: code, deptName: department.value },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Set the combined data in the state
      setItemOptions(response.data.map((item) => ({
        value: item.printName,
        label: `${item.printName} ${item.additionalNames ? ` - [ ${item.additionalNames} ]` : ''}`,
        itemCode: item.itemCode,
        uom: item.uom,
        unit: item.unit,
        itemId: item.id
      })));
    } catch (error) {
      console.error('Error fetching or merging item data:', error.message);
      console.error('Details:', error.response?.data || error.message);
    }
  };

  const handleAddRow = () => {
    setInventory([
      ...inventory,
      {
        item: null,
        quantity: '',
        approvedQuantity: '', // ✅ NEW
        itemCode: '',
        uom: '',
        unit: '',
        returnable: null,
        itemRemarks: ''
      }
    ]);
  };


  const handleRemoveRow = (index) => {
    setInventory(inventory.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!header.date) {
      Swal.fire({
        icon: 'error',
        title: 'Please select a date.',
        toast: true,
        position: 'top-end',
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    // Validate Receiving Department
    if (!header.receivingDepartment) {
      Swal.fire({
        icon: 'error',
        // title: 'Validation Error',
        text: 'Receiving Department is required.',
        position: 'top-end',
        toast: true,
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    // Validate Issuer Department
    if (!header.issuerDepartment) {
      Swal.fire({
        icon: 'error',
        // title: 'Validation Error',
        text: 'Issuer Department is required.',
        position: 'top-end',
        toast: true,
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    if (!header.transaction) {
      Swal.fire({
        icon: 'error',
        title: 'Please select a transaction.',
        toast: true,
        position: 'top-end',
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    // Check if Receiving and Issuer Departments are the same
    if (
      header.receivingDepartment?.value === header.issuerDepartment?.value ||
      header.receivingDepartment === header.issuerDepartment
    ) {
      Swal.fire({
        icon: 'error',
        // title: 'Validation Error',
        text: 'Receiving and Issuer Departments cannot be the same.',
        position: 'top-end',
        toast: true,
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    for (let i = 0; i < inventory.length; i++) {
      const item = inventory[i];
      if (!item.item) {
        Swal.fire({
          icon: 'error',
          // title: 'Validation Error',
          text: `Please select an item at row ${i + 1}.`,
          position: 'top-end',
          toast: true,
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      const qty = parseFloat(item.quantity);

      if (item.quantity === '' || isNaN(qty) || qty <= 0) {
        Swal.fire({
          icon: 'error',
          text: `Please enter a valid quantity at row ${i + 1}.`,
          position: 'top-end',
          toast: true,
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }
      if (
        item.approvedQuantity !== '' &&
        (isNaN(parseFloat(item.approvedQuantity)) || parseFloat(item.approvedQuantity) < 0)
      ) {
        Swal.fire({
          icon: 'error',
          text: `Please enter a valid approved quantity at row ${i + 1}.`,
          position: 'top-end',
          toast: true,
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }


      if (item.returnable === null || item.returnable === undefined) {
        Swal.fire({
          icon: 'error',
          // title: 'Validation Error',
          text: `Please specify if the item is returnable at row ${i + 1}.`,
          position: 'top-end',
          toast: true,
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }
    }
    // ================= PIN CONFIRMATION =================
    const { value: enteredPin } = await Swal.fire({
      title: 'Enter PIN',
      input: 'password',
      inputPlaceholder: 'Enter your PIN',
      inputAttributes: {
        maxlength: 6,
        autocapitalize: 'off',
        autocorrect: 'off',
      },
      showCancelButton: true,
      confirmButtonText: 'Verify',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'PIN is required';
        }
      },
    });

    // If cancelled
    if (!enteredPin) return;

    // Match PIN
    if (String(enteredPin) !== String(pin)) {
      Swal.fire({
        icon: 'error',
        text: 'Invalid PIN. Please try again.',
        toast: true,
        position: 'top-end',
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    try {
      const payload = {
        requestDate: header.date,
        receivingDepartment: header.receivingDepartment?.value || header.receivingDepartment,
        issuerDepartment: header.issuerDepartment?.value || header.issuerDepartment,
        transaction: header.transaction?.value || header.transaction,
        remarks: header?.remarks,
        projectId: header.project?.value,
        projectName: header.project?.label,
        code,
        createdBy: name,
        createdByBadge: badgeId,
        inventory_data: inventory.map((item) => {
          const qty = parseFloat(item.quantity);
          const approvedQty =
            item.approvedQuantity === '' ||
              item.approvedQuantity === null ||
              item.approvedQuantity === undefined
              ? qty
              : parseFloat(item.approvedQuantity);

          return {
            item: item.item?.value || item.item,
            itemId: item.item.itemId,
            quantity: qty,
            approvedQuantity: approvedQty, // ✅ decimal supported
            unit: item.unit || '',
            itemCode: item.itemCode || '',
            uom: item.uom || '',
            returnable: item.returnable?.value || null,
            itemRemarks: item.itemRemarks,
          };
        }),

      };
      if (draftId) {
        await apiClient.put(`${SERVER_BASE}/updateRequest/${draftId}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        Swal.fire({
          icon: 'success',
          title: 'Updated!',
          text: 'Request updated successfully.',
          position: 'top-end',
          toast: true,
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        await apiClient.post(SERVER_BASE + '/addRequest', payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        Swal.fire({
          icon: 'success',
          title: 'Created!',
          text: 'Request saved successfully.',
          position: 'top-end',
          toast: true,
          timer: 2000,
          showConfirmButton: false,
        });
      }

      setHeader({ receivingDepartment: null, issuerDepartment: null, remarks: '' });
      setInventory([{ item: null, quantity: '', itemCode: '', uom: '', unit: '', returnable: null, itemRemarks: '' }]);
      navigate('../issueRequest')
      // fetchDrafts();
    } catch (error) {
      console.error('Error submitting request:', error);
      alert('Error submitting request.');
    }
  };

  return (
    <div className="container mt-5">
      <h3 className="mb-3">{draftId ? 'Edit Request' : 'Issue Request'}</h3>

      {/* Form */}
      <form onSubmit={handleSubmit} className="">
        <div className='d-flex justify-content-between'>

          <button
            onClick={() => {
              navigate('../issueRequest')
            }}
            className="btn btn-success mb-3"
            type='button'
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-success mb-3">
            {draftId ? 'Update & Approve' : 'Save & Approve'}
          </button>
        </div>
        <div className="row mb-3 formcontainer">
          <div className="col-md-3">
            <label htmlFor="date" className="form-label">Date</label>
            <input
              type="date"
              id="date"
              className='form-control'
              value={header.date}
              onChange={(e) => setHeader({ ...header, date: e.target.value })}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="receivingDepartment" className="form-label">
              Receiving Department
            </label>
            <Select
              id="receivingDepartment"
              options={departments}
              value={header.receivingDepartment}
              onChange={(selected) =>
                setHeader({ ...header, receivingDepartment: selected })
              }
              isClearable
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="issuerDepartment" className="form-label">
              Issuer Department
            </label>
            <Select
              id="issuerDepartment"
              options={departments}
              value={header.issuerDepartment}
              onChange={(selected) => {
                setHeader({ ...header, issuerDepartment: selected })
                fetchItemOptions(selected)
              }}
              isClearable
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="transaction" className="form-label">Transaction</label>
            <Select
              id="transaction"
              options={transactionOptions}
              value={header.transaction}
              onChange={(selected) => setHeader({ ...header, transaction: selected })}
              isClearable
            />
          </div>
          {(header.transaction?.value == 'Project') && (
            <div className="col-md-12">
              <label htmlFor="project" className="form-label">
                Project
              </label>
              <Select
                id="project"
                options={projects}
                value={header.project}
                onChange={(selected) => {
                  setHeader({ ...header, project: selected })
                }}
                isClearable
              />
            </div>
          )}
          <div className="col-md-12">
            <label htmlFor="remarks" className="form-label">
              Remarks
            </label>
            <input
              type="text"
              id="remarks"
              className="form-control"
              value={header.remarks}
              onChange={(e) =>
                setHeader({ ...header, remarks: e.target.value })
              }
            />
          </div>
        </div>

        <div className='formcontainer'>
          <div className="row align-items-center">
            <div className="col-md-3"><label className="form-label">Item</label></div>
            <div className="col-md-1"><label className="form-label">Required</label></div>
            <div className="col-md-1"><label className="form-label">UOM</label></div>
            {type != 'Own' ? <>

              <div className="col-auto fw-bold">||</div>
              <div className="col-md-1"><label className="form-label">Approved</label></div>
              <div className="col-md-1"><label className="form-label">UOM</label></div>
            </> : null}

            <div className="col-md-1"><label className="form-label">Returnable</label></div>
            <div className="col-md-2"><label className="form-label">Remarks</label></div>
            <div className="col-md-1"></div>
          </div>

          {inventory.map((data, index) => (
            <div className="row mb-2 align-items-center" key={index}>

              <div className="col-md-3">
                <Select
                  options={itemOptions}
                  value={data.item}
                  onChange={(selected) =>
                    setInventory(prev => {
                      const updated = [...prev];
                      const selectedItem = itemOptions.find(
                        option => option.value === selected.value
                      );
                      updated[index] = {
                        ...updated[index],
                        item: selectedItem,
                        itemCode: selectedItem?.itemCode || '',
                        uom: selectedItem?.uom || '',
                        unit: selectedItem?.unit || '',
                      };
                      return updated;
                    })
                  }
                />
              </div>

              <div className="col-md-1">
                <input
                  className="form-control"
                  value={data.quantity}
                  onChange={e => {
                    const v = [...inventory];
                    v[index].quantity = e.target.value;
                    setInventory(v);
                  }}
                />
              </div>

              <div className="col-md-1">
                <input className="form-control" value={data.uom} readOnly />
              </div>

              {type != 'Own' ? <>
                <div className="col-md-auto text-center fw-bold">||</div>

                <div className="col-md-1">
                  <input
                    className="form-control"
                    value={data.approvedQuantity || ''}
                    onChange={e => {
                      const v = [...inventory];
                      v[index].approvedQuantity = e.target.value;
                      setInventory(v);
                    }}
                  />
                </div>

                <div className="col-md-1">
                  <input className="form-control" value={data.uom} readOnly />
                </div>
              </>
                : null}

              {/* 🔁 NORMAL SELECT — LOGIC PRESERVED */}
              <div className="col-md-1">
                <select
                  className="form-select"
                  value={data.returnable?.value || ""}
                  onChange={(e) => {
                    const v = [...inventory];
                    v[index].returnable = e.target.value
                      ? { value: e.target.value, label: e.target.value }
                      : null;
                    setInventory(v);
                  }}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="col-md-2">
                <input
                  className="form-control"
                  value={data.itemRemarks}
                  onChange={e => {
                    const v = [...inventory];
                    v[index].itemRemarks = e.target.value;
                    setInventory(v);
                  }}
                />
              </div>

              <div className="col-md-1 d-flex gap-1">
                <button className="btn btn-success btn-sm" type="button" onClick={handleAddRow}>
                  <FontAwesomeIcon icon={faPlus} />
                </button>
                {inventory.length > 1 && (
                  <button
                    className="btn btn-danger btn-sm"
                    type="button"
                    onClick={() => handleRemoveRow(index)}
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </button>
                )}
              </div>

            </div>
          ))}
        </div>
      </form>
    </div>
  );
};

export default IssueRequest;

